import { useEffect } from 'react';
import { useSectionContext } from '../../../context/section';
import { registerField, unregisterField } from '../../../stream/transfer/control';
import useControlNext from '../../state/useControlNext';
/**
 * Provides field registration on mount and unregistration on unmount
 *
 * @documented
 * @category Field
 * @import import useFieldRegistration from '@gef-ui/form-core/hooks/field/useFieldRegistration'
 * @param {Object} input
 * @param {String} input.fieldName
 * @param {Number[]} [input.fieldIndices] - indices for array, can be nested and sorted by path of nesting
 * @param {boolean} [input.initiallyDirty]
 * @param {String} [input.defaultValue]
 * @param {String} [formName] - when used, formStream$ is taken from stream storage instead of context
 * @example
 *
 * 	useFieldRegistration({fieldName: 'xxx'});
 *
 */ const useFieldRegistration = ({ fieldName, fieldIndices, initiallyDirty, disabled, defaultValue }, formName)=>{
    const next = useControlNext(formName);
    const section = useSectionContext();
    // biome-ignore lint/correctness/useExhaustiveDependencies: disabled is not present because it is only for initial load
    useEffect(()=>{
        if (next) {
            next(registerField({
                fieldName,
                fieldIndices,
                initiallyDirty,
                section,
                disabled,
                defaultValue
            }));
            return ()=>{
                next(unregisterField({
                    fieldName,
                    fieldIndices,
                    initiallyDirty,
                    section
                }));
            };
        }
    }, [
        fieldName,
        initiallyDirty,
        next,
        fieldIndices,
        section
    ]);
};
export default useFieldRegistration;
